import React, { useState } from 'react';

import { ExpandLess, ExpandMore } from '@mui/icons-material';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import {
  Box,
  Typography,
  Paper,
  Chip,
  IconButton
} from '@mui/material';

import QnaRating from './QnaRating';
import Logo from '../assets/images/app-logo-single.webp';

const CandidateQnaCard = ({ qna }) => {
  const [expanded, setExpanded] = useState(true);
  return (
    <Paper elevation={0} sx={{ p: 3, mt: 2, bgcolor: '#f8f9fa' }}    >
      {/* Header with Suggested and Rating */}
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box src={Logo} component='img' sx={{ width: '19px', height: '25px' }} />
          {qna?.suggested &&
            <Typography fontWeight={500} sx={{ fontSize: '0.875rem' }}>
              Suggested
            </Typography>
          }
          <QnaRating value={(qna?.match_score / 100) * 5} />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <IconButton size="small" sx={{ color: '#666' }}>
            <TextFieldsIcon />
          </IconButton>
          <IconButton size="small" sx={{ color: '#666' }} onClick={() => setExpanded(!expanded)}>
            {expanded ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        </Box>
      </Box>

      {expanded && (
        <>

          {/* Question */}
          <Box sx={{ mb: 2 }}>
            <Chip
              label="Question"
              size="small"
              sx={{
                bgcolor: '#4CC4FF',
                color: 'white',
                fontSize: '0.75rem',
                height: 24,
                mb: 1
              }}
            />
            <Typography sx={{ color: '#2C3E50', fontSize: '0.875rem', lineHeight: 1.5 }}>
              {qna?.question}
            </Typography>
          </Box>

          {/* Expected Answer */}
          <Box sx={{ mb: 2 }}>
            <Chip
              label="Expected Answer"
              size="small"
              sx={{
                bgcolor: '#4CC4FF',
                color: 'white',
                fontSize: '0.75rem',
                height: 24,
                mb: 1
              }}
            />
            <Typography sx={{ color: '#2C3E50', fontSize: '0.875rem', lineHeight: 1.5 }}>
              {qna?.expected_ans}
            </Typography>
          </Box>

          {/* Candidate Answer */}
          <Box sx={{ mb: 2 }}>
            <Chip
              label="Candidate answer"
              size="small"
              sx={{
                bgcolor: '#FFB400',
                color: 'white',
                fontSize: '0.75rem',
                height: 24,
                mb: 1
              }}
            />
            <Typography sx={{ color: '#2C3E50', fontSize: '0.875rem', lineHeight: 1.5 }}>
              {qna?.answer}
            </Typography>
          </Box>

        </>
      )}

      {/* Match Score */}
      <Typography sx={{ color: '#666', fontSize: '0.75rem', mt: 2 }}>
        {`Matched ${qna?.match_score || 0}% to the expected answer`}
      </Typography>
    </Paper>
  );
};

export default CandidateQnaCard;